import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../components/layout/Layout";
import AppHeader from "../../common/components/app-header";
import UInput from "ubs-framework/v2/UInput";
import Validator from "simple-react-validator"
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import { showToastError, showToastSuccess } from "ubs-framework/v2/common/function";
import { sendData } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useSocket from "../../common/useSocket";
import UButton from "ubs-framework/v2/UButton";
import LayoutV2 from "../../../components/layout-v2";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const TWOFARecoveryCode = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const forceUpdate = useForceUpdate();
    const _LID = useSelector(e => e?.common?.logInDetails)
    const _AD = useSelector(e => e?.common?.authData)
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));
    const [fieldValue, setFieldValue] = useState({
        recoveryCode: ''
    })
    const [errorMsg, setErrorMsg] = useState("");

    const inputChange = (e) => {
        let {name, value} = e.target;
        setFieldValue((val) => {
            return {...val, [name]: value}
        })
    }

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            sendData(dispatch, 'hrms|master|MFA|verify', {
                recoveryCode: fieldValue?.recoveryCode
            })
        } else {
            validator?.current?.showMessages()
        }
    }

    const onKeyUp = e => {
        if (e.key === "Enter") onSubmit(e)
    }

    useEffect(() => {
        if(_AD ? false : (!_LID?.identifier || !_LID?.password)) {
            history.push('/login')
        }
    }, [_LID, _AD])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'hrms|master|MFA|verify':
                    if (res?.data?.success) {
                        showToastSuccess('Recovery Code verified successfully')
                        history.push('/setup-multi-factor')
                    }
                    else showToastError('Invalid Recovery Code')
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res?.error?.message ?? res?.data?.error ?? '')
            switch (res?.code) {
                case 401:
                    history.push('/login')
                    break;
                default:
                    return true;
            }
        }
    })

    useEffect(() => {
        refresh();
        return () => off();
    }, [])

    return (
        <React.Fragment>
            <LayoutV2 module="recoveryCode" className="u_two-fa-setup">
               <div className="u_p-24">

                   <div className="u_text-center u_mb-24">
                       <h3 className="u_title u_text-bold u_mb-12">Add Recovery Code</h3>
                       <p className="u_small-font">Enter the recovery code to verify your account.</p>
                   </div>

                   <div className="u_mt-24">
                       <UInput
                           hasError={validator?.current?.message("recoveryCode", fieldValue?.recoveryCode, "required")}
                           className="u_mb-10"
                           label="Recovery Code"
                           asterisk
                           testId={TEST_ID.TWO_FA_RECOVERY.INPUT_WRAPPER}>
                           <input
                               onChange={inputChange}
                               value={fieldValue?.recoveryCode}
                               type="text"
                               onKeyUp={onKeyUp}
                               name="recoveryCode"
                               placeholder=" "
                               autoComplete="off"
                               data-testid={TEST_ID.TWO_FA_RECOVERY.RECOVERY_CODE_INPUT} />
                       </UInput>
                       <p className="u_small-font u_mb-20">E.x. rt1n-54So</p>

                       {errorMsg.length !== 0 && <p className="u_error-message">{errorMsg}</p>}
                       
                       <div className="u_block u_relative">
                           <button
                               type="button"
                               onClick={onSubmit}
                               className={`u_acc-btn u_w-full u_cp`}
                               data-testid={TEST_ID.TWO_FA_RECOVERY.SAVE_BUTTON}>Save</button>
                       </div>
                   </div>
               </div>
           </LayoutV2>
        </React.Fragment>
    );
}

export default TWOFARecoveryCode;